import React, { useEffect, useState, lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Layout, Modal, BackTop, Icon } from "antd";
import config from "appConfig";
import { withSize } from "react-sizeme";
import { General } from "../../routes/General";
import utilsStyles from "./../../styles/utils.scss";
import {
  getModules,
  getCategories,
  updateCurrentModule,
} from "./actions";
import { selectCategories, selectModules, selectCurrentModule, selectRoutes } from "./selectors";
import {
  selectAdDetails,
  setSearchText,
  deleteSubLevelSearch,
  selectForbidAds
} from "../../routes/Ad/ad.ducks";
import { syncSavedSearch, updateCriteriaModules, selectResults } from "../../routes/Search/search.ducks";
import { Header, Help, Footer, MobileAppBanner } from "../../components";
import UserProfilePage from "../UserProfilePage";
import VerifyAccountPage from "../VerifyAccountPage";
import ModuleContext from "../../ModuleContext";
import WidthContext from "../../WidthContext";
// import Admin from "../../routes/Admin";
const Admin = lazy(() => import("../../routes/Admin"));
// import TermsOfUse from "../../components/Help/TermsOfUse";
const TermsOfUse = lazy(() => import("../../components/Help/TermsOfUse"));
// import PrivacyPolicy from "../../components/Help/PrivacyPolicy";
const PrivacyPolicy = lazy(() => import("../../components/Help/PrivacyPolicy"));
// import Advertising from "../../components/Help/Advertising";
const Advertising = lazy(() => import("../../components/Help/Advertising"));
// import InstructionsForUse from "../../components/Help/InstructionsForUse";
const InstructionsForUse = lazy(() =>
  import("../../components/Help/InstructionsForUse")
);
// import FAQ from "../../components/Help/FAQ";
const FAQ = lazy(() => import("../../components/Help/FAQ"));
import { InvalidPage } from "../../components/InvalidPage";
import { getUserProfile, selectLoadedUser, selectProfileLoading } from "../../routes/Auth/auth.ducks";
import HomePage from "../HomePage/index";
// const HomePage = lazy(() => import("../HomePage/index"));
import OtherCategories from "../HomePage/OtherCategories";
// const OtherCategories = lazy(() => import("../HomePage/OtherCategories"));
import RedirectingToAd from "../RedirectingToAd";
// const RedirectingToAd = lazy(() => import("../RedirectingToAd"));
import {
  getUrlParams,
  scrollToTop,
  isMediumScreen,
  generateTargetingTags,
  checkEmptyObject,
  destroyAdSlot,
  buildBaseUrl,
  trackLastClickedSearchAdNavigation
} from "../../services";
import history from "../../history";
import {
  PageRoute,
  CategoryNameHr,
} from "../../models/enums";
import AdsSellerPage from "../AdsSellerPage";
// const AdsSellerPage = lazy(() => import("../AdsSellerPage"));
import RatingsSellerPage from "../RatingsSellerPage";
import MyRatingsPage from "../MyRatingsPage/index";
import FavoritePage from "../FavoritePage/index";
// const FavoritePage = lazy(() => import("../FavoritePage/index"));
import MyAdsPage from "../MyAdsPage";
// const MyAdsPage = lazy(() => import("../MyAdsPage"));
import ChatsPage from "../ChatsPage/ChatsPage";
import SavedSearchPage from "../SavedSearchPage";
// const SavedSearchPage = lazy(() => import("../SavedSearchPage"));
import SearchPage from "../SearchPage";
// const SearchPage = lazy(() => import("../SearchPage"));
import "./app.scss";
import SettingsPage from "../SettingsPage";
// const SettingsPage = lazy(() => import("../SettingsPage"));
import ChangePassword from "../ChangePassword/ChangePassword";
// const ChangePassword = lazy(() => import("../ChangePassword/ChangePassword"));
import SelectModulePage from "../SelectModulePage";
// const SelectModulePage = lazy(() => import("../SelectModulePage"));
import { getFavoriteIds, syncFavorites } from "../../routes/Favorite/favorite.ducks";
import { syncFollowedStores } from "../../routes/Store/store.ducks";
import { getHiddenAdIds } from "../../routes/Hidden/hidden.ducks";
import ReactGA from "react-ga4";
import { GaContext } from "../../GAContext";
import { ShareContext } from "../../ShareContex";
import styles from "./app.scss";
import { NotificationUnsubscribe } from "../NotificationUnsubscribe";
import usePrevious from "../../utils/usePrevious";
import {
  adDetailsInterface,
  rootReducerInterface,
  routeInterface,
  UserI
} from "../../typings/interfaces";
import { CategoriesI, ModulesI } from "../../typings/routesTypes";
import VerifyModal from "../../components/VerifyModal";
import { Loading } from "../../components/Loading";
import EditModulePage from "../EditModulePage";
import { getRoutes } from "./actions";
import appConfig from 'appConfig';
import AdPromotePage from "../AdPromotePage";
import CreditsPage from "../CreditsPage";
import FinancePage from "../FinancePage";
import AdStatisticsPage from "../AdStatisticsPage";
import GoogleAd from "../../components/GoogleAd";
import { StickySkyBanners } from "./StickySkyBanners";
import GoogleOneTap from "../../components/GoogleOneTap";
import { googleAds } from "appConfig";
import { getUnreadCount } from "../../routes/Chat/chat.ducks";
import { getSystemMessageUnreadCount } from "../../routes/SystemMessage/systemMessage.ducks";
import { useThrottle } from "../../hooks/useThrottle";
import { AIFeedbackModal } from "./AIFeedbackModal";
import { ContactButton } from "../../components/ContactButton/ContactButton";
import { PollPopup } from "../../components/PollPopup";
import { getVerifyModalContent } from "../../services/getVerifyModalContent";
// const EditModulePage = lazy(() => import("../EditModulePage"));

interface AppProps {
  className?: string | undefined;
  currentAd?: adDetailsInterface;
  currentModule?: string;
  deleteSubLevelSearch?: Function;
  getCategories?: Function;
  getRoutes?: Function;
  getModules?: Function;
  location?: Location;
  routes?: routeInterface[];
  modules?: ModulesI[];
  categories?: CategoriesI[];
  setSearchText?: Function;
  size?: { width?: number; height?: string; position?: string };
  style?: undefined;
  searchText?: string;
  updateCriteriaModules?: Function;
  updateCurrentModule?: Function;
  getUserProfile?: Function;
  syncFavorites?: Function;
  getFavoriteIds?: Function;
  getHiddenAdIds?: Function;
  syncSavedSearch?: Function;
  syncFollowedStores?: Function;
  user?: UserI;
  profileLoading?: boolean;
  forbiddAds?: boolean;
  searchResults?: any;
}

const PostAdHash = "#post-ad";
const UnsubscribeHash = "#unsubscribed-from-notifications";

function extractPrebidObjects(obj) {
  const prebidObjects = [];

  function recurse(current) {
    if (current instanceof Array) {
      current.forEach(item => recurse(item));
    } else if (current instanceof Object) {
      if (current.hasOwnProperty('prebid')) {
        current.prebid.forEach(prebidItem => {
          prebidItem.code = current.path;
          prebidObjects.push(prebidItem)
        }
        );
      }
      Object.values(current).forEach(value => recurse(value));
    }
  }

  recurse(obj);
  return prebidObjects;
}

interface VerifyModalI {
  heading: string;
  content: string;
  redirectPath: string;
  okText?: string;
  cancelText?: string;
}

const blankVerifyModal: VerifyModalI = {
  heading: "",
  content: "",
  redirectPath: "",
};

const App: React.FC<AppProps> = props => {
  const [isShowModuleModal, setIsShowModuleModal] = useState(false);
  const [isShowUnsubscribeModal, setIsShowUnsubscribeModal] = useState(false);
  const [showHeaderLogoAndSearchBar, setShowHeaderLogoAndSearchBar] = useState(true);
  const [verifyModal, setVerifyModal] = useState(blankVerifyModal);

  const {
    user,
    profileLoading,
    location: { pathname, search },
    getRoutes,
    getModules,
    getCategories,
    setSearchText,
    deleteSubLevelSearch,
    updateCriteriaModules,
    routes,
    modules,
    categories,
    currentModule,
    updateCurrentModule,
    size: { width },
    currentAd,
    getUserProfile,
    syncFavorites,
    getFavoriteIds,
    getHiddenAdIds,
    syncSavedSearch,
    syncFollowedStores,
    searchResults
  } = props;
  const [isHomePage, setIsHomePage] = useState(pathname === "/");

  const prevModule = usePrevious(currentModule);
  const dispatch = useDispatch();
  const isMobile = isMediumScreen(width);
  const D_STICKY = "googleAds.D_sticky_all";
  const M_STICKY = "googleAds.M_sticky_all";

  // Debounce timer for Satismeter initialization
  let satismeterDebounceTimer: NodeJS.Timeout | null = null;

  // Initialize Satismeter with debounce
  const initializeSatismeter = () => {
    // Clear any existing timer
    if (satismeterDebounceTimer) {
      clearTimeout(satismeterDebounceTimer);
    }

    // Set a new timer with 500ms delay
    satismeterDebounceTimer = setTimeout(() => {
      if (!window.satismeter) {
        (function () {
          window.satismeter = window.satismeter || function () {
            (window.satismeter.q = window.satismeter.q || []).push(arguments);
          };
          window.satismeter.l = 1 * new Date();
          var script = document.createElement("script");
          var parent = document.getElementsByTagName("script")[0].parentNode;
          script.async = 1;
          script.src = "https://app.satismeter.com/js";
          parent.appendChild(script);
        })();
      }
      // Trigger Satismeter with configuration on each route change
      const config = {
        writeKey: appConfig.satismeter && appConfig.satismeter.writeKey
      };

      satismeter(config);
    }, 500);
  };

  useEffect(() => {
    getRoutes(
      encodeURIComponent(pathname)
    )
  }, [pathname]);

  useEffect(() => {
    if (routes.length > 0) {
      //TagManager.initialize({gtmId: 'GTM-PSBVFWW'})
      ReactGA.initialize("G-TMGNPD1D7Z");

      history.listen((location) => {
        // @ts-ignore
        window.dm = window.dm || {
          AjaxEvent: function () {
            console.warn("DotMetrics not loaded yet");
          }
        };

        // @ts-ignore
        dm.AjaxEvent("pageview");
      });
    }
  }, [routes.length]);

  const handleHistoryListenChange = () => {
    dispatch(getUnreadCount());
    dispatch(getSystemMessageUnreadCount());
  }
  const handleHistoryListenChangeThrottled = useThrottle(handleHistoryListenChange, 10000)

  useEffect(() => {
    getUserProfile(user, (user: UserI) => {
      if (checkEmptyObject(user)) {
        if (user.isBlocked) {
          window.location.replace(buildBaseUrl("/authentication/logout"));
          return;
        }

        syncFavorites(user, (user: UserI) => getFavoriteIds(user));
        syncFollowedStores(user);
        getHiddenAdIds();
        syncSavedSearch(user);

        dispatch(getUnreadCount());
        dispatch(getSystemMessageUnreadCount());
        history.listen(() => {
          handleHistoryListenChangeThrottled()
        });
      }
    });
  }, []);

  useEffect(() => history.listen(trackLastClickedSearchAdNavigation), []);

  useEffect(() => {
    initializeSatismeter();
    generateTargetingTags();

    history.listen(() => {
      initializeSatismeter();
      generateTargetingTags();
    });

    // @ts-ignore
    window.notFound = false;

    var googletag = window.googletag || {};
    googletag.cmd = googletag.cmd || [];

    var pbjs = window.pbjs || {};
    pbjs.que = pbjs.que || [];

    googletag.cmd.push(function () {
      pbjs.que.push(function () {
        pbjs.addAdUnits(
          extractPrebidObjects(appConfig.googleAds)
        );
        googletag.pubads().disableInitialLoad();
        //googletag.pubads().setCentering(true);
        googletag.enableServices();
      });
    });
  }, []);

  useEffect(() => {
    getModules();
    getCategories();
    updateModuleAfterRouteChange();
  }, []);


  useEffect(() => {
    // if (location.hash === PostAdHash && user != null) {
    //   setIsShowModuleModal(true);
    // }

    if (location.hash === UnsubscribeHash) {
      setIsShowUnsubscribeModal(true);
    }

    if (pathname == "/") {
      setIsHomePage(true);

      if (showHeaderLogoAndSearchBar) { setShowHeaderLogoAndSearchBar(false); }

      if (currentModule != "") { updateCurrentModule("") }

    } else {
      // if pathname is changed
      setIsHomePage(false);
      updateModuleAfterRouteChange();
    }

    const searchParams = getUrlParams(search);
    if (searchParams && searchParams.text) {
      setSearchText(searchParams.text);
    }

    if (currentModule != prevModule) {
      handleModuleChange();
    }

    handleLocationChange(props);
  }, [
    user != null, // TODO: Davor - check if this could be removed
    JSON.stringify(user) != JSON.stringify({}), // TODO: Davor - check if this could be removed
    pathname,
    currentModule
  ]);

  const shouldHideStickyAd = () => {
    // Check if the last path segment matches main category value
    const lastPathSegment = pathname.split("/").pop();
    const isMainCategoryMatch = Object.values(CategoryNameHr).includes(lastPathSegment);

    // Category level is 4)
    return (
      isMainCategoryMatch ||
      // pathname.includes(PageRoute.details) ||
      pathname.includes(PageRoute.postAd) ||
      pathname.includes(PageRoute.user) ||
      (routes && routes[0] && routes[0].Component === "4") // Category level is 4
    );
  };

  const shouldShowStickyAdOnSearchPage = () => {
    // On search pages, only show sticky ads if there are actual results
    if (pathname.includes(PageRoute.search)) {
      return searchResults && searchResults.data && searchResults.data.length > 0;
    }
    // On non-search pages, return true (let shouldHideStickyAd handle it)
    return true;
  };


  const handleModuleChange = () => {
    // setIsShowModuleModal(false);
    deleteSubLevelSearch();
  };

  const handleLocationChange = (props: AppProps) => {
    const { location } = props;
    if (!pathname.includes(PageRoute.search) ||
      props.location.pathname !== location.pathname) {
      setTimeout(() => {
        scrollToTop();
      });
    }

    if (
      location.pathname.includes(PageRoute.search) &&
      !pathname.includes(PageRoute.search)
    ) {
      updateCriteriaModules(null);
    }
  };

  function updateModuleAfterRouteChange() {
    let module = pathname.split("/")[1];

    if (module && module != "pretraga") {
      if (module !== currentModule) {
        if (JSON.stringify(modules) != JSON.stringify([])) {
          if (!modules.find(m => m.route === module)) {
            module = "";
          }
        }

        updateCurrentModule(module);
      }
    } else {
      updateCurrentModule("");
    }
  }

  const handleSubmitAdClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (user && (user.hasInvalidUsername || !user.isVerified || !user.hasVerifiedPhoneNumber)) {
      setVerifyModal(getVerifyModalContent(user));
      return;
    }

    history.push(PageRoute.postAd);

  };

  const handleCancelModal = () => {
    // setIsShowModuleModal(false);
    history.goBack();
    // window.history.replaceState(null, window.document.title, " ");
  };

  const handleCancelUnsubscribeModal = () => {
    setIsShowUnsubscribeModal(false);

    window.history.replaceState(null, window.document.title, " ");
  };

  const showHeaderLogoAndSearchBarHandler = () => {
    setShowHeaderLogoAndSearchBar(true);
  };

  const hideHeaderLogoAndSearchBar = () => {
    setShowHeaderLogoAndSearchBar(false);
  };

  return (
    <GaContext>
      <WidthContext.Provider value={width}>
        <ShareContext>
          <GoogleOneTap isLoggedIn={user !== null && typeof user === 'object' && Object.keys(user).length > 0} profileLoading={profileLoading} />
          <Suspense
            fallback={
              <Loading className={`${utilsStyles.PT20} ${utilsStyles.PB20}`} />
            }
          >
            <Switch>
              <Route path="/admin" component={Admin} />
              <Route path="/mobile/terms-of-use" exact component={TermsOfUse} />
              <Route
                path="/mobile/privacy-policy"
                exact
                component={PrivacyPolicy}
              />
              <Route path="/mobile/advertising" exact component={Advertising} />
              <Route
                path="/mobile/instructions-for-use"
                exact
                component={InstructionsForUse}
              />
              <Route path="/mobile/faq" exact component={FAQ} />
              <ModuleContext.Provider value={currentModule}>
                <Layout className="layout">
                  {config.mobileLink ? (
                    <MobileAppBanner
                      currentAd={currentAd}
                      pathname={location.pathname}
                    />
                  ) : null}
                  <Header
                    onSubmitAdClick={handleSubmitAdClick}
                    transparent={isHomePage && !showHeaderLogoAndSearchBar}
                    isHomePage={isHomePage}
                    showLogoAndSearchBar={showHeaderLogoAndSearchBar}
                    user={user}
                  />
                  <Layout.Content style={{ minHeight: "100vh" }}> {/* workaround to avoid cumulative Layout Shift (CLS) issue */}
                    {/* Pages map module / category routes to API names through the global
                        modules and categories (LanguageMapper), and their first requests fire on
                        mount - so both lists must be loaded before any page renders. */}
                    {(modules.length > 0 && categories.length > 0 && routes.length) ? (
                      <React.Fragment>
                        {/* Dont show sticky ad on certain pages or when ads are forbidden */}
                        {(!shouldHideStickyAd() && shouldShowStickyAdOnSearchPage() && !isMobile && !props.forbiddAds) && (
                          <GoogleAd
                            className={`${styles.ads} ${styles.adPlaceholder2} ${styles.stickyAd}`}
                            config={{ ...googleAds.D_sticky_all, id: D_STICKY }}
                          />
                        )}

                        {(!shouldHideStickyAd() && shouldShowStickyAdOnSearchPage() && isMobile && !props.forbiddAds) && (
                          <GoogleAd
                            className={`${styles.ads} ${styles.adPlaceholder2} ${styles.stickyAd}`}
                            config={{ ...googleAds.M_sticky_all, id: M_STICKY }}
                          />
                        )}

                        {/* Sky banners sit off to the side of the content
                            column, so they don't need the same "crowded page"
                            gate as the bottom sticky slot (which hides on
                            main category tile grids). Keep them visible on
                            every public browsing page; only skip post-ad /
                            user profile / 18+ / mobile contexts. Key by
                            pathname so a route change remounts GoogleAd and
                            pulls a fresh creative. */}
                        {(() => {
                          if (isMobile) return null;
                          if (pathname.includes(PageRoute.postAd)) return null;
                          if (pathname.includes(PageRoute.user)) return null;
                          if (!shouldShowStickyAdOnSearchPage()) return null;
                          // Deliberately not reading props.forbiddAds here:
                          // AdList / AdDetailsPage set it to true on 18+
                          // modules/categories/ads but don't clear it when
                          // the user navigates to a non-ad page (eg. saved
                          // ads), so it would stale-hide sky banners for
                          // the rest of the session. Derive 18+ directly
                          // from the current URL — React Router strips the
                          // /oglasi baseFolder, so pathname is
                          // /{module}/{category}/..., ie. segments[1] is
                          // the module and segments[2] is the category.
                          const segments = pathname.split("/");
                          const pathModule = segments[1];
                          const pathCategory = segments[2];
                          const module18Plus = modules && modules.some(
                            m => m.route === pathModule && m.is18Old
                          );
                          const category18Plus = categories && categories.some(
                            c => c.route === pathCategory && c.is18Old
                          );
                          if (module18Plus || category18Plus) return null;
                          return <StickySkyBanners key={pathname} forbiddAds={false} />;
                        })()}

                        <Switch>
                          <Route
                            path="/"
                            exact
                            render={props => (
                              <HomePage
                                {...props}
                                hideHeaderLogoAndSearchBar={
                                  hideHeaderLogoAndSearchBar
                                }
                                showHeaderLogoAndSearchBar={
                                  showHeaderLogoAndSearchBarHandler
                                }
                                onSubmitAdClick={handleSubmitAdClick}
                              />
                            )}
                          />
                          <Route
                            path={PageRoute.postAd}
                            exact
                            component={SelectModulePage}
                          />
                          <Route
                            path={`${PageRoute.editAd}/:id`}
                            exact
                            component={EditModulePage}
                          />
                          <Route
                            path={`${PageRoute.promote}/:id`}
                            exact
                            component={AdPromotePage}
                          />
                          <Route
                            path={`${PageRoute.statistics}/:id`}
                            exact
                            component={AdStatisticsPage}
                          />
                          <Route
                            path={`${PageRoute.verifyEmail}/:code`}
                            exact
                            component={VerifyAccountPage}
                          />

                          <Route path={`${PageRoute.help}/:menu`} component={Help} />

                          <Route
                            path={PageRoute.search}
                            exact
                            render={props => (
                              <SearchPage
                                {...props}
                                showHeaderLogoAndSearchBar={
                                  showHeaderLogoAndSearchBarHandler
                                }
                              />
                            )}
                          />
                          <Route
                            path={`${PageRoute.user}/:username`}
                            exact
                            component={AdsSellerPage}
                          />
                          <Route
                            path={`${PageRoute.user}/:username${PageRoute.userRatings}`}
                            exact
                            component={RatingsSellerPage}
                          />
                          <Route
                            path={PageRoute.profile}
                            exact
                            component={UserProfilePage}
                          />
                          <Route
                            path={PageRoute.favorite}
                            exact
                            render={props => (
                              <FavoritePage
                                {...props}
                                showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBarHandler()}
                              />
                            )}
                          />
                          <Route
                            path={PageRoute.myAd}
                            exact
                            component={MyAdsPage}
                          />
                          <Route
                            path={PageRoute.myRatings}
                            exact
                            component={MyRatingsPage}
                          />

                          <Route
                            path={PageRoute.chats}
                            component={ChatsPage}
                          />

                          <Route
                            path={PageRoute.finance}
                            exact
                            component={FinancePage}
                          />
                          <Route
                            path={PageRoute.credits}
                            exact
                            component={CreditsPage}
                          />
                          <Route
                            path={PageRoute.savedSearch}
                            exact
                            component={SavedSearchPage}
                          />
                          <Route
                            path={PageRoute.settings}
                            exact
                            component={SettingsPage}
                          />
                          <Route
                            path={PageRoute.changePassword}
                            exact
                            component={ChangePassword}
                          />

                          {modules.map(m => (
                            <Route
                              key={m.name}
                              path={`/${m.route}`}
                              render={props => (
                                <General
                                  {...props}
                                  // @ts-ignore
                                  showHeaderLogoAndSearchBar={
                                    showHeaderLogoAndSearchBarHandler
                                  }
                                  routes={routes}
                                />
                              )}
                            />
                          ))}

                          <Route component={InvalidPage} />
                          <Route component={RedirectingToAd} />
                        </Switch>
                        <AIFeedbackModal />
                        <ContactButton />
                        <PollPopup />

                      </React.Fragment>
                    ) : (
                      <div className={`${utilsStyles.PT20} ${utilsStyles.PB20}`}>
                        <Loading />
                      </div>
                    )}
                  </Layout.Content>
                  {history.location.pathname !== PageRoute.chats && <Footer />}
                  <Modal
                    width={width > 1920 ? "1727px" : "90%"}
                    footer={null}
                    visible={isShowModuleModal}
                    onCancel={handleCancelModal}
                    className={styles.categoriesModal}
                  >
                    <div className={styles.title}>
                      {"Odaberite kategoriju u kojoj će se prikazati Vaš oglas"}
                    </div>
                    <OtherCategories title="" redirectUrl={PageRoute.postAd} />
                  </Modal>

                  <VerifyModal
                    visible={verifyModal.heading !== "" && verifyModal.content !== "" && verifyModal.redirectPath !== ""}
                    onOk={() => {
                      history.push(verifyModal.redirectPath), setVerifyModal(blankVerifyModal);
                    }}
                    onCancel={event => {
                      event.preventDefault(), setVerifyModal(blankVerifyModal);
                    }}
                    onClose={() => setVerifyModal(blankVerifyModal)}
                    closable={false}
                    className={styles.modal}
                    {...verifyModal}
                  />
                  <Modal
                    width={width > 1920 ? "1500px" : "70%"}
                    footer={null}
                    visible={isShowUnsubscribeModal}
                    onCancel={handleCancelUnsubscribeModal}
                  >
                    <NotificationUnsubscribe />
                  </Modal>
                  <BackTop className={history && history.location && history.location.pathname && history.location.pathname.includes(PageRoute.details) ? styles.backTopDetails : styles.backTop} />
                </Layout>
              </ModuleContext.Provider>
            </Switch>
          </Suspense>
        </ShareContext>
      </WidthContext.Provider>
    </GaContext>
  );
};

App.defaultProps = {
  user: null,
  currentAd: {}
};

export default connect(
  (state: rootReducerInterface) => ({
    routes: selectRoutes(state),
    modules: selectModules(state),
    categories: selectCategories(state),
    currentModule: selectCurrentModule(state),
    user: selectLoadedUser(state),
    profileLoading: selectProfileLoading(state),
    currentAd: selectAdDetails(state),
    location: state.router.location,
    forbiddAds: selectForbidAds(state),
    searchResults: selectResults(state)
  }),
  {
    getRoutes,
    getModules,
    getCategories,
    getUnreadCount,
    updateCurrentModule,
    setSearchText,
    updateCriteriaModules,
    deleteSubLevelSearch,
    getUserProfile,
    syncFavorites,
    getFavoriteIds,
    getHiddenAdIds,
    syncSavedSearch,
    syncFollowedStores
  }
)(withSize()(App));



// WEBPACK FOOTER //
// ./src/containers/App/index.tsx